import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';

const DEFAULT_WIDTH = 434;
const DEFAULT_HEIGHT = 478;

const DEFAULT_FONT_FAMILY = 'Inter';
const DEFAULT_BORDER_WIDTH = 2;
const DEFAULT_BORDER_COLOR = '#FFF';
const DEFAULT_LABEL_COLOR = '#FFF';
const DEFAULT_CLOUD_BUBBLE_CHART_DATA = {
  legend: {
    enabled: true,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  title: {
    text: 'Inclusive organizations from 2010 to 2030',
  },
  dataLabels: {
    inside: false,
    enabled: true,
    style: {
      ...DEFAULT_TEXT_STYLE,
      fontFamily: DEFAULT_FONT_FAMILY,
      color: DEFAULT_LABEL_COLOR,
    },
  },
  seriesData: extendSeriesData([
    {
      name: 'Category',
      data: ['Public Sector', 'Education', 'Technology'],
    },
    {
      name: '2010',
      data: [18, 12, 6],
    },
    {
      name: '2020',
      data: [24, 16, 8],
    },
    {
      name: '2030',
      data: [30, 20, 10],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
  xAxis: {
    gridLineWidth: 0,
    title: {
      text: '',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
    style: {
      lineColor: '#DBDBDB',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    gridLineWidth: 0,
    title: {
      text: '',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
    style: {
      lineColor: '#DBDBDB',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
  generalOptions: {
    innerSize: 0,
    borderWidth: DEFAULT_BORDER_WIDTH,
    borderColor: DEFAULT_BORDER_COLOR,
  },
  patterns: {
    enabled: false,
    list: [],
  },
};

export {
  DEFAULT_BORDER_COLOR,
  DEFAULT_BORDER_WIDTH,
  DEFAULT_CLOUD_BUBBLE_CHART_DATA,
  DEFAULT_HEIGHT,
  DEFAULT_LABEL_COLOR,
  DEFAULT_WIDTH,
};
